@if (store.selectedTable && store.columns.length && (store.availableLookupTables.length || store.lookupDefinitions.length)) {
  <div class="import-lookups__intro">
    <p class="import-lookups__intro-text">{{ 'TRANS__IMPORT__LOOKUPS__INTRO' | translate }}</p>
    <button mat-stroked-button type="button" color="primary" class="import-lookups__add"
            [disabled]="!store.availableLookupTables.length" (click)="add()">
      <mat-icon>add</mat-icon>
      <span class="bold uppercase">{{ 'TRANS__IMPORT__LOOKUP_ADD' | translate }}</span>
    </button>
  </div>

  @if (store.lookupSuggestions; as suggestions) {
    @if (suggestions.length) {
      <section class="import-lookups__suggestions" aria-labelledby="import-lookups-suggestions">
        <div class="import-lookups__heading">
          <mat-icon aria-hidden="true">lightbulb</mat-icon>
          <h4 id="import-lookups-suggestions">{{ 'TRANS__IMPORT__LOOKUPS__SUGGESTIONS' | translate }}</h4>
        </div>
        @for (suggestion of suggestions; track suggestionKey(suggestion)) {
          <div class="import-lookups__suggestion">
            <div class="import-lookups__suggestion-text">
              <span class="import-lookups__flow">
                <span class="import-lookups__column-name">{{ suggestion.code_column }}</span>
                <mat-icon aria-hidden="true">arrow_forward</mat-icon>
                <span class="import-lookups__table-name">{{ suggestion.table }}</span>
                <span class="import-lookups__key-column">.{{ suggestion.key_column }}</span>
              </span>
              <span class="import-lookups__muted">
                {{ 'TRANS__IMPORT__LOOKUPS__SUGGESTION_COVERAGE' | translate: {
                  codesMatched: suggestion.codes_matched, codesTotal: suggestion.codes_total,
                  rowsMatched: suggestion.rows_matched, rowsWithCode: suggestion.rows_with_code
                } }}
                @if (directUsages(suggestion); as usages) {
                  {{ 'TRANS__IMPORT__LOOKUPS__SUGGESTION_USED_DIRECTLY' | translate: {usages: usages} }}
                } @else {
                  {{ 'TRANS__IMPORT__LOOKUPS__SUGGESTION_UNUSED' | translate }}
                }
              </span>
              @if (suggestion.key_is_running_number) {
                <span class="import-lookups__caution">{{ 'TRANS__IMPORT__LOOKUPS__SUGGESTION_RUNNING_NUMBER' | translate }}</span>
              }
            </div>
            <div class="import-lookups__actions">
              <button mat-stroked-button type="button" color="primary" class="import-lookups__accept"
                      (click)="accept(suggestion)">
                <span class="bold uppercase">{{ 'TRANS__IMPORT__LOOKUPS__SUGGESTION_ACCEPT' | translate }}</span>
              </button>
              <button mat-button type="button" color="primary" class="import-lookups__dismiss"
                      (click)="store.dismissLookupSuggestion(suggestion)">
                <span class="bold uppercase">{{ 'TRANS__IMPORT__LOOKUPS__SUGGESTION_DISMISS' | translate }}</span>
              </button>
            </div>
          </div>
        }
      </section>
    }
  }

  <section class="import-lookups__section" [attr.aria-label]="'TRANS__IMPORT__LOOKUPS_SECTION' | translate">
    @if (store.lookupCheckError) {
      <div class="import-lookups__failed">
        <span class="import-lookups__error">{{ store.lookupCheckError }}</span>
        <button mat-stroked-button type="button" color="primary" class="import-lookups__retry"
                [disabled]="store.lookupChecking" (click)="store.retryLookupCheck()">
          <span class="bold uppercase">{{ 'TRANS__IMPORT__LOOKUPS__RETRY' | translate }}</span>
        </button>
      </div>
    }
    <mat-card appearance="outlined">
      <mat-card-content>
        <app-lookup-definitions
          [lookups]="store.lookupDefinitions"
          [tables]="store.availableLookupTables"
          [tableColumns]="store.lookupColumns"
          [tableColumnsLoading]="store.lookupColumnsLoading"
          [tableColumnsFailed]="store.lookupColumnsFailed"
          [columns]="store.columns"
          [checks]="store.lookupChecks"
          [checkPending]="store.lookupCheckPending"
          [checkFailed]="!!store.lookupCheckError"
          [columnProblems]="store.lookupColumnProblems"
          [usages]="store.lookupUsages"
          [(expanded)]="expandedLookup"
          (remove)="store.removeLookup($event)"
          (meansBlank)="meansBlank($event)"
          (retryColumns)="store.retryLookupColumns($event)"
        ></app-lookup-definitions>
        @if (!store.lookupDefinitions.length) {
          <p class="import-lookups__muted import-lookups__empty">{{ 'TRANS__IMPORT__LOOKUPS__NONE' | translate }}</p>
        }
      </mat-card-content>
    </mat-card>
  </section>
}
